import classNames from "classnames";
import React from "react";
import * as styles from "./styles.module.scss";
export const DATA_PROTECTION_STATEMENT = "The data displayed is sourced from BioPAT® Process Insights";
const DataProtectionText = ({ printable = false, classname = "" }) => (React.createElement("div", { className: classNames(styles["data-protection-text"], classname, { [styles.printable]: printable }) },
    React.createElement("p", null,
        DATA_PROTECTION_STATEMENT,
        " and its use is subject to and bound by the terms and conditions set out in the",
        " ",
        React.createElement("a", { target: "_blank", href: "/TAP EULA BioPAT Process Insights.pdf" }, "EULA"),
        ".")));
export default DataProtectionText;
